import { motion } from 'motion/react'
import ActionButton from 'src/components/ActionButton'
import BlockTitle from 'src/components/BlockTitle'
import Picture from 'src/components/Picture'
import RichText from 'src/components/RichText'
import Slider from 'src/components/Slider'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(144)};
  }
`
export const _BlockTitle = styled(BlockTitle)`
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`
export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: ${pxToRem(16)} 1fr;
  grid-template-rows: auto auto auto;
  @media ${mq(sizes.desktop)} {
    grid-template-columns: ${pxToRem(32)} 1fr ${pxToRem(32)};
  }
`
export const _Picture = styled(motion.create(Picture))`
  position: relative;
  z-index: 2;
  grid-column: 2 / span 1;
  grid-row: 1 / span 2;
  @media ${mq(sizes.desktop)} {
    grid-column: 2 / span 2;
  }
`
export const SliderWrapper = styled(motion.div)`
  position: relative;
  z-index: 2;
  grid-column: 1 / span 2;
  grid-row: 3 / span 1;
  padding-block: ${pxToRem(32)} ${pxToRem(40)};
  padding-inline: ${pxToRem(16)};
  @media ${mq(sizes.desktop)} {
    padding-inline: ${pxToRem(32)};
  }
`

export const _Slider = styled(Slider)`
  overflow: hidden;
  & .keen-slider[data-keen-slider-disabled],
  & .keen-slider:not([data-keen-slider-disabled]) {
    overflow: visible;
  }
  @media ${mq(sizes.desktop)} {
    & .keen-slider {
      display: flex;
      flex-flow: row;
      gap: ${pxToRem(24)};
    }
    & .keen-slider__slide {
      flex: 1 1 0;
    }
  }
`

export const Push = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  transition: opacity 0.2s ease-in-out;
  min-height: 100%;
  overflow: hidden;
  @media ${mq(sizes.desktop)} {
    padding-inline-start: ${pxToRem(24)};
  }
  @media ${mq(sizes.desktop)} and (hover: hover) {
    ${_Slider}:has(&:hover) &:not(:hover) {
      opacity: 0.4;
    }
  }
`
export const PushTitle = styled(motion.h3)`
  ${({ theme }) => theme.textStyles.m375_h2}
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h2}
  }
`
export const PushText = styled(RichText)`
  ${({ theme }) => theme.textStyles.m375_body}
  padding-inline-end: ${pxToRem(30)};
  @media ${mq(sizes.desktop)} {
    padding-inline-end: 0;
  }
`
export const PushAction = styled(ActionButton)`
  align-self: flex-start;
  margin-block-start: auto;
`
export const PushSeparator = styled(motion.span)`
  display: none;
  @media ${mq(sizes.desktop)} {
    display: block;
    background: rgba(0, 0, 0, 0.1);
    overflow: hidden;
    &,
    &::after {
      content: '';
      position: absolute;
      inset: 0 auto 0 0;
      width: 1px;
    }
    &::after {
      transform: translateY(-100%);
      transition: transform 0.3s ease-out 0.2s;
      background: rgba(0, 0, 0, 0.2);
    }
    ${Push}:hover &::after {
      transform: translateY(0);
    }
  }
`
export const Decoration = styled.div<{ $color?: string }>`
  position: relative;
  z-index: 1;
  grid-column: 1 / span 2;
  grid-row: 2 / span 2;
  background-color: ${({ $color }) => $color};
`
